// making these string enumerations helps with parsing json
export enum SectionTypes {
  cooking_appliance = 'cooking_appliance',
  corner_radius = 'corner_radius',
  custom_side = 'custom_side',
  cutouts = 'cutouts',
  diagonal_corners = 'diagonal_corners',
  dishwasher = 'dishwasher',
  edge = 'edge',
  faucet = 'faucet',
  refrigerator = 'refrigerator',
  sink = 'sink',
  tear_out_countertop = 'tear_out_countertop',
}
